export default function useDataConfiguration({ thread_id, patient_id }) {
  return {
    variables: {
      id: thread_id,
      patient_id: patient_id,
      includePatient: !!patient_id,
    },
    pause: !thread_id,
  }
}
